import { lighten, darken } from 'polished'

const colorOffsetLight = 0.15
const colorOffsetDark = 0.07

export default {
	orientationQueries: {
		portrait: '(orientation: portrait)',
		landscape: '(orientation: landscape)',
	},
	mediaQueries: {
		mobile: '(max-width: 767px)',
		mobileXXs: '(max-width: 320px)',
		mobileXs: '(min-width: 320px) and (max-width: 375px)',
		mobileX: '(min-width: 376px) and (max-width: 480px)',
		mobileXl: '(min-width: 480px) and (max-width: 767px)',
		tablet: '(min-width: 768px) and (max-width: 991px)',
		tabletXS: '(min-width: 768px)',
		desktop: '(min-width: 991px)',
		desktopX: '(min-width: 991px) and (max-width: 1279px)',
		desktopXl: '(min-width: 1280px)',
		mobileXsHeight: '(min-height: 400px)',
		mobileXHeight: '(min-height: 600px)',
		mobileXlHeight: '(min-height: 700px)',
		mobileXXlHeight: '(min-height: 800px)',
	},
	gradient: {
		primary: 'linear-gradient(left, #76C4E2, #85CBA8)',
		two: 'linear-gradient(left, #8176B5, #85CBA8)',
		three: 'linear-gradient(left, #8176B5, #76C4E2)',
		four: 'linear-gradient(left, #8176B5, #BA77B1)',
		five: 'linear-gradient(left, #8176B5, #F16975)',
		six: 'linear-gradient(left, #F16975, #F69259)',
		seven: 'linear-gradient(left, #F69259, #FFDB6F)',
		eight: 'linear-gradient(left, #85CBA8, #FFDB6F)',
	},
	color: {
		// Style guide colors
		rain: '#408BC9',
		sky: '#76C4E2',
		dew: '#85CBA8',
		twilight: '#8176B5',
		sunset: '#BA77B1',
		dawn: '#F16975',
		sunrise: '#F69259',
		lightning: '#FFDB6F',
		night: '#404041',
		dusk: '#4D4D4F',
		storm: '#808285',
		hail: '#BCBEC0',
		moonshine: '#F7F7F7',
		mineShaft: '#3a3a3a',
		// current colors
		cement: '#7D7D7D',
		grass: '#9BCA3E',
		marine: '#2F7BBF',
		tangerine: '#FF7900',
		apple: '#BD2527',
		charcoal: '#333333',
		carrot: '#f56500',
		smoke: '#e0e0e0',
		seaGreen: '#4CD9AA',
		darkGrey: '#999999',
		lightGray: '#eeeeee',
		lightPurple: '#99B2DD',
		azureRadiance: '#0078ff',
		whisper: '#F5F5FA',
		riceFlower: '#eaffe2',
		sunglo: '#E56A6A',
		tundora: '#4A4A4A',
		dustyGray: '#9B9B9B',
		scorpion: '#5F5F5F',
		silver: '#BABABA',
		doveGray: '#666666',
		whiteSmoke: '#F5F5F5',
		grassGreen: '#429D1C',
		kindaBlue: '#f2f8ff',
		homeDeliveryBlack: '#4a505d',
		disabledGray: '#bdbdbd',
		blackishBlue: '#1f2533',
		davyGray: '#555555',
		grimGray: '#777777',
		washedAzure: '#1985ff',
		lightAzure: '#4da1ff',
		darkOrange: '#F3993E',
		lightGrey: '#f2f2fa',
		bgHighlightBlue: '#eef6ff',
	},
	fontSize: {
		xxs: 10,
		xs: 11,
		s: 12,
		m: 14,
		l: 16,
		xl: 18,
		xxl: 20,
	},
	letterSpacing: {
		xs: 1,
	},
	boxShadow: {
		thick: '0 0 20px 0 rgba(136,136,136,0.50)',
		thin: '0px 1px 4px #ccc',
	},
	statusIndicators: {
		live: '#4abd5d',
		inProcess: '#ffcb01',
		inactive: '#eeeeee',
	},
	regularBaseFont: {
		fontFamily: 'roboto',
		fontWeight: '400',
	},
	mediumBaseFont: {
		fontFamily: 'roboto',
		fontWeight: '500',
	},
	boldBaseFont: {
		fontFamily: 'roboto',
		fontWeight: '700',
	},
	inputFontSize: '13',
	lineHeight: 1.5,
	inputLineHeight: 1.4,
	em: '1em',
	rem: '1rem',
	fontFamily: '"Open Sans", Helvetica, Arial, sans-serif',
	fontWeight: 400,
	fontWeightLight: 300,
	fontWeightSemiBold: 600,
	fontWeightBold: 700,
	fontColorHeadingCaption: '#888',
	border: '1px solid #ccc',
	borderRadius: '2',
	arrowSize: '5',
	disabledInputColor: 'rgba(204, 204, 204, 0.4)',
	disabledBackground: '#ededed',
	bodyBackground: '#ebebeb',
	bodyAccentColor: darken(0.8, '#fff'),
	bodyOffsetColor: darken(0.53, '#fff'),
	fontColor: darken(0.8, '#fff'),
	colorWhite: '#fff',
	colorBlack: '#000',
	colorTransparent: 'transparent',
	colorOffsetLight,
	colorOffsetDark,
	colorInfo: '#00a9eb',
	colorSuccess: '#68970f',
	colorWarning: '#fca520',
	colorError: '#ff3100',
	colorMuted: darken(0.5125, '#fff'),
	colorSmoke: '#f2f2f2',
	colorBlue: '#007aff',
	colorBlueLight: lighten(colorOffsetLight, '#007aff'),
	colorBlueDark: darken(colorOffsetDark, '#007aff'),
	colorOrange: '#ff7900',
	colorOrangeLight: lighten(colorOffsetLight, '#ff7900'),
	colorOrangeDark: darken(colorOffsetDark, '#ff7900'),
	colorGray: '#80848f',
	colorGrayLight: darken(0.13, '#80848f'),
	colorGrayLightOnboarding: '#F7F7F7',
	colorGrayDark: darken(0.5, '#80848f'),
	colorGrayBorder: '#666',
	colorGreen: '#9bca3e',
	colorGreenLight: lighten(colorOffsetLight, '#9bca3e'),
	colorGreenDark: darken(colorOffsetDark, '#9bca3e'),
	colorRed: '#e6324B',
	colorRedLight: lighten(colorOffsetLight, '#e6324B'),
	colorRedDark: darken(colorOffsetDark, '#e6324B'),
	colorYellow: '#ffd24d',
	colorYellowLight: lighten(colorOffsetLight, '#ffd24d'),
	colorYellowDark: darken(colorOffsetDark, '#ffd24d'),
	colorPink: '#d91698',
	colorPinkLight: lighten(colorOffsetLight, '#d91698'),
	colorPinkDark: darken(colorOffsetDark, '#d91698'),
	colorPurple: '#9545e5',
	colorPurpleLight: lighten(colorOffsetLight, '#d91698'),
	colorPurpleDark: darken(colorOffsetDark, '#d91698'),
	colorTwitterBlue: '#00aced',
	colorFacebookBlue: '#3b5998',
	colorMainBackground: '#e6e6e6',
	colorPurpleApp: '#343546',
	colorOverlay: 'rgba(0, 0, 0, .7)',
	colorImportantInformation: 'rgba(64,139,201,0.2)',
	colorToolTipAlert: '#ffbf00',
	zIndex: {
		deep: -1,
		level1: 0,
		level2: 100,
		level3: 200,
		level4: 500,
		level5: 999,
	},
	font: {
		size10: 10,
		size12: 12,
		size14: 14,
		size16: 16,
		size18: 18,
		size20: 20,
		size24: 24,
		size28: 28,
		size30: 30,
		size34: 34,
		size48: 48,
		size60: 60,
		size72: 72,
		weight100: 100,
		weight200: 200,
		weight300: 300,
		weight400: 400,
		weight500: 500,
		weight600: 600,
		weight700: 700,
	},
	colors: {
		white: '#FFFFFF',
		lightBg: '#FBFDFF',
		bmsLightBlue: '#ECF5FF',
		bmsBlue: '#3E6EEA',
		bmsDarkBlue: '#2B3148',
		bmsDeepBlue: '#1F253A',
		bmsPurple: '#4F3385',
		lightGrey4: '#EEEEEE',
		lightGrey3: '#DDDDDD',
		lightGrey2: '#CCCCCC',
		grey5: '#808080',
		darkGrey6: '#999999',
		darkGrey5: '#666666',
		darkGrey4: '#222222',
		pastelGreen: '#F1FAF2',
		successGreen: '#4ABD5D',
		pastelYellow: '#FFF9E3',
		yellow: '#FFCB01',
		pastelOrange: '#FDF4DB',
		orange: '#F3993E',
		pastelRed: '#FBEBEB',
		bmsRed: '#E7364D',
		errorRed: '#CD0000',
		bmsPink: '#EC5E71',
		redTwo: '#F84464',
		redTwoMuted: '#FBA1B1',
		shimmerGrey: '#F2F2F2',
		bmsInfo: '#F2F5F9',
		transparent: 'transparent',
		inherit: 'inherit',
		black: '#000000',
		bmsSuccess: '#008A1E',
		readyGreen: '#4ABD5D',
		periwinkle: 'rgba(191, 209, 255, 0.2)',
		smokeBlue: '#EBF0FF',
		infoThree: '#FFF3D2',
		bmsGreen: '#1EA83C',
		darkGrey7: '#333333',
		lightBlue1: '#f2f2fa',
		lightGrey5: '#EDF0F4',
		lightBlue2: '#A0A7C5',
		lightGrey6: '#E6E6E6',
		lightYellow: '#FFE49B',
		gold: '#C99303',
	},
	gradients: {
		primary:
			'linear-gradient(180deg, rgba(0, 0, 0, 0.84) 0%, rgba(0, 0, 0, 0.3) 62.5%, rgba(0, 0, 0, 0) 100%)',
	},
	buttonVariants: {
		primary: '#0378FF',
		success: '#0378FF',
		danger: '#CD0000',
		info: '#5bc0de',
		default: 'lightgray',
		accent: '#ff4081',
		disabled: '#DDDDDD',
		white: '#fff',
		pay: '#0378FF',
	},
	spaces: {
		4: '4px',
		6: '6px',
		8: '8px',
		10: '10px',
		12: '12px',
		14: '14px',
		16: '16px',
		20: '20px',
		24: '24px',
		28: '28px',
		30: '30px',
		32: '32px',
		36: '36px',
		40: '40px',
		44: '44px',
		48: '48px',
		52: '52px',
		56: '56px',
		60: '60px',
		64: '64px',
		80: '80px',
		84: '84px',
		88: '88px',
		100: '100px',
		120: '120px',
		180: '180px',
	},
	shadows: {
		elevation2:
			'0px 4px 4px rgba(0, 0, 0, 0.08), 0px 2px 2px rgba(0, 0, 0, 0.08)',
		elevation4:
			'0px 4px 24px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.08)',
		elevation8:
			'0px 4px 32px rgba(0, 0, 0, 0.08), 0px 4px 8px rgba(0, 0, 0, 0.08)',
		elevation16:
			'0px 4px 48px rgba(0, 0, 0, 0.08), 0px 8px 12px rgba(0, 0, 0, 0.08)',
		elevation24:
			'0px 4px 56px rgba(0, 0, 0, 0.04), 0px 12px 16px rgba(0, 0, 0, 0.04)',
	},
	// themes
	primary: theme => ({
		color: theme.colors.bmsDeepBlue,
		backgroundColor: theme.colors.bmsBlue,
		pageBackground: theme.colors.lightGrey4,
		shadow: theme.shadows.elevation4,
		colorWhite: theme.colors.white,
		fontFamily: 'roboto',
		hoverColor: theme.colors.lightGrey3,
		disabledColor: theme.colors.lightGrey3,
		inputDisabledColor: theme.colors.lightGrey4,
		errorColor: theme.colors.errorRed,
		borderColor: theme.colors.lightGrey3,
		borderLight: theme.colors.lightGrey3,
		borderRadius: theme.spaces['4'],
		formTextColor: theme.colors.darkGrey6,
		successColor: theme.colors.successGreen,
		shimmerColor: theme.colors.shimmerGrey,
		whiteColor: theme.colors.white,
	}),
	secondary: theme => ({
		color: theme.colors.bmsDeepBlue,
		backgroundColor: theme.colors.bmsPink,
		shadow: theme.shadows.elevation4,
		colorWhite: theme.colors.white,
		fontFamily: 'Noto Serif',
		hoverColor: theme.colors.lightGrey4,
		disabledColor: theme.color.lightGrey4,
		errorColor: theme.colors.errorRed,
		borderColor: theme.colors.lightGrey3,
		borderLight: theme.colors.lightGrey4,
		borderRadius: theme.spaces['6'],
		formTextColor: theme.colors.darkGrey6,
		successColor: theme.colors.successGreen,
		shimmerColor: theme.colors.shimmerGrey,
	}),
	tertiary: theme => ({
		color: theme.colors.bmsDeepBlue,
		backgroundColor: theme.colors.bmsPink,
		shadow: theme.shadows.elevation4,
		colorWhite: theme.colors.white,
		fontFamily: 'Panton',
		hoverColor: theme.colors.lightGrey4,
		disabledColor: theme.color.lightGrey4,
		errorColor: theme.colors.errorRed,
		borderColor: theme.colors.lightGrey3,
		borderLight: theme.colors.lightGrey4,
		borderRadius: theme.spaces['4'],
		formTextColor: theme.colors.darkGrey6,
		successColor: theme.colors.successGreen,
		shimmerColor: theme.colors.shimmerGrey,
	}),
}
